export enum wasabiImagePath {
    VENDOR_ATTACHMENT = "vendor/attachments",
    TICKET_ATTACHMENT = "ticket/attachments",
    VENDOR_IMAGE = "vendor/image",

    SUPERADMIN = 'superadmin/image',
    DISTRIBUTOR = 'distributor/image',
    AGENT = 'agent/image',
}
